import { API_ENDPOINTS } from "config/config";
import { buildAnalyticsQueryParams } from "utils/analyticsQueryParams";

const get = async (api, endpoint, params = {}) => {
  const response = await api.get(endpoint, {
    params: buildAnalyticsQueryParams(params),
  });
  return response.data.data;
};

export const getFunnelMetrics = (api, params) =>
  get(api, API_ENDPOINTS.FUNNEL_METRICS, params);

export const getPipelineDistribution = (api, params = {}) => {
  const { locationId, filters } = params;
  return get(api, API_ENDPOINTS.FUNNEL_PIPELINE_DISTRIBUTION, {
    ...(filters ? { filters } : {}),
    ...(locationId ? { locationId } : {}),
  });
};

export const getRevenueByStage = (api, params) =>
  get(api, API_ENDPOINTS.FUNNEL_REVENUE_BY_STAGE, params);

export const getDestinationBreakdown = (api, params) =>
  get(api, API_ENDPOINTS.FUNNEL_DESTINATION_BREAKDOWN, params);
